module.exports = __webpack_public_path__ + "img/thumb_18.e704fe54.png";